import login from './login';

export default {
  language: 'fa-IR',
  country: 'ir',
  name: 'فارسی',
  embeddedLocale: login,
};
